import React from 'react';

const GolfCourseNav = ({
  handleAnchorClick,
  activeSection,
  onPrevCourse,
  onNextCourse,
  prevDisabled,
  nextDisabled,
}) => {
  const navButtonBaseClasses =
    'h-full py-2 px-4 block focus:outline-none whitespace-nowrap';
  const activeNavButtonClasses = 'text-indigo-700 border-b-2 border-indigo-700';
  const inactiveNavButtonClasses =
    'text-gray-800 border-b-2 border-gray-300 hover:text-blue-500';

  return (
    <>
      <header className="border-b sticky z-50 w-full bg-white top-0">
        <div className="w-full px-2 sm:px-4">
          {/* Mobile: Prev/Next row above tabs */}
          <div className="sm:hidden flex items-center justify-between gap-2 py-2">
            <button
              type="button"
              onClick={onPrevCourse}
              disabled={!!prevDisabled}
              className="px-3 py-2 text-xs font-semibold text-slate-900 border rounded-lg border-slate-200 hover:border-slate-400 hover:text-indigo-700 disabled:text-slate-400 disabled:cursor-not-allowed whitespace-nowrap"
              aria-label="Previous course"
            >
              ← Prev
            </button>
            <button
              type="button"
              onClick={onNextCourse}
              disabled={!!nextDisabled}
              className="px-3 py-2 text-xs font-semibold text-slate-900 border rounded-lg border-slate-200 hover:border-slate-400 hover:text-indigo-700 disabled:text-slate-400 disabled:cursor-not-allowed whitespace-nowrap"
              aria-label="Next course"
            >
              Next →
            </button>
          </div>

          {/* Tabs row (always visible) */}
          <div className="h-[65px] sm:h-[67px] flex items-stretch justify-between gap-2">
            {/* Desktop: Prev on left */}
            <button
              type="button"
              onClick={onPrevCourse}
              disabled={!!prevDisabled}
              className="hidden sm:inline-flex items-center h-full px-3 sm:px-4 text-xs sm:text-sm font-semibold text-slate-900 border-b-2 border-transparent hover:text-indigo-700 disabled:text-slate-400 disabled:cursor-not-allowed whitespace-nowrap"
              aria-label="Previous course"
            >
              ← Prev
            </button>

            <div className="h-full flex-1 flex sm:justify-center overflow-x-auto scrollbar-hide">
              <button
                className={`${navButtonBaseClasses} ${
                  activeSection === 'rank'
                    ? activeNavButtonClasses
                    : inactiveNavButtonClasses
                } sm:text-sm`}
                onClick={(event) =>
                  handleAnchorClick(event, '#golfCourseRank', 'rank')
                }
              >
                Ranking
              </button>
              <button
                className={`${navButtonBaseClasses} ${
                  activeSection === 'about'
                    ? activeNavButtonClasses
                    : inactiveNavButtonClasses
                } sm:text-sm`}
                onClick={(event) =>
                  handleAnchorClick(event, '#golfCourseAbout', 'about')
                }
              >
                About
              </button>
              <button
                className={`${navButtonBaseClasses} ${
                  activeSection === 'greenFees'
                    ? activeNavButtonClasses
                    : inactiveNavButtonClasses
                } sm:text-sm`}
                onClick={(event) =>
                  handleAnchorClick(event, '#golfCourseGreenFees', 'greenFees')
                }
              >
                Green Fees
              </button>
              <button
                className={`${navButtonBaseClasses} ${
                  activeSection === 'visitorInfo'
                    ? activeNavButtonClasses
                    : inactiveNavButtonClasses
                } sm:text-sm`}
                onClick={(event) =>
                  handleAnchorClick(event, '#visitorInfo', 'visitorInfo')
                }
              >
                Visitor Info
              </button>
            </div>

            {/* Desktop: Next on right */}
            <button
              type="button"
              onClick={onNextCourse}
              disabled={!!nextDisabled}
              className="hidden sm:inline-flex items-center h-full px-3 sm:px-4 text-xs sm:text-sm font-semibold text-slate-900 border-b-2 border-transparent hover:text-indigo-700 disabled:text-slate-400 disabled:cursor-not-allowed whitespace-nowrap"
              aria-label="Next course"
            >
              Next →
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default GolfCourseNav;
